import React, { useContext } from 'react';
import { BoxNotification } from 'components/containers/BoxNotification';
import { BeaconContext } from 'providers/BeaconProvider';
import { Modal } from 'components/containers/Modal';
import { AppContext } from 'providers/AppProvider';

export const SpamLockedModal = () => {
  const { setSuspendedModalOpen } = useContext(AppContext);
  const { beacon } = useContext(BeaconContext);
  const handleClickContactUs = () => {
    beacon('open');
    beacon('navigate', '/ask');
    setSuspendedModalOpen(false);
  };

  return (
    <Modal size={'small'} title={'Temporarily locked'} onClose={() => setSuspendedModalOpen(false)}>
      <div>
        <BoxNotification type="error">
          <>
            <span>To protect against spam, publishing from this Organization is temporarily locked.</span>
            <br />
            <span>
              Please <a onClick={handleClickContactUs}>contact us</a> to unlock your account.
            </span>
          </>
        </BoxNotification>
      </div>
    </Modal>
  );
};
